// A MAC is 12 hex characters (6 bytes); displayed colon-separated that's
// 17 ("AA:BB:CC:DD:EE:FF"). Re-derives the colons from scratch on every
// keystroke rather than inserting them incrementally, so pasting, typing,
// and backspacing all just work without separate-case handling — matches
// the same 12-hex-character rule the backend's normalizeMac enforces.
export function formatMacInput(raw) {
  const hex = raw.toUpperCase().replace(/[^0-9A-F]/g, "").slice(0, 12);
  return hex.match(/.{1,2}/g)?.join(":") || "";
}
